import React from 'react';
import Css from './Footer.module.css'
import { BsTwitter } from 'react-icons/bs';
import { FiGithub } from 'react-icons/fi';
import { FaLinkedinIn } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';

export default function Footer() {
  return (<div id='footer' className={Css.footer}>
    <div className={Css.linkContainer} id="Contacts">

      <a href="https://twitter.com/Shweta_2217" className={Css.link} target="_blank" rel="noreferrer"><BsTwitter /></a>

      <a href="https://www.linkedin.com/in/shweta-s-14b613212" target="_blank" className={Css.link} rel="noreferrer" ><FaLinkedinIn /></a>

      <a href="https://github.com/Shweta2217" target="_blank" className={Css.link} rel="noreferrer" ><FiGithub /></a>

      <a href="mailto:shwetasaini2217@gmail.com" target="_blank" className={Css.link} rel="noreferrer" ><MdEmail /></a>

    </div>

    <div className={Css.copyright}>
      Made with &#10084; by Shweta
    </div>
    
  </div>);
}
